import { useCallback } from 'react';

export const useDropdownToggle = (
  setSearchQuery: (value: string) => void,
  setOpened: (value: boolean) => void,
): ((isOpen: boolean, isFirstOpen?: boolean) => void) => {
  return useCallback(
    (isOpen: boolean, isFirstOpen?: boolean) => {
      if (!isOpen) {
        setSearchQuery('');
      }
      if (isFirstOpen && isOpen) {
        setOpened(true);
      }
    },
    [setSearchQuery, setOpened],
  );
};
